import { Button, Dialog } from "@validereinc/common-components";
import React from "react";

export const BulkDeleteFormSubmissionDialog = ({
  isOpen,
  onClose,
  handleBulkDelete,
  formSubmissionsCount,
}: {
  isOpen: boolean;
  onClose: () => void;
  handleBulkDelete: () => Promise<void>;
  formSubmissionsCount: number;
}) => {
  const subject =
    formSubmissionsCount === 1 ? "Form Submission" : "Form Submissions";
  const BULK_DELETE_FORM_SUBMISSION_DIALOG_TITLE = `Delete ${formSubmissionsCount} ${subject}?`;
  const BULK_DELETE_FORM_SUBMISSION_DIALOG_DESCRIPTION = `Are you sure you want to delete ${formSubmissionsCount === 1 ? "this" : "these"} ${subject}? This will break any cascading logic with other resources such as workflows. This action cannot be undone.`;

  return (
    <Dialog
      title={BULK_DELETE_FORM_SUBMISSION_DIALOG_TITLE}
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          key="delete-question-action"
          variant="error"
          onClick={() => {
            handleBulkDelete();
            onClose();
          }}
        >
          Delete
        </Button>,
      ]}
    >
      {BULK_DELETE_FORM_SUBMISSION_DIALOG_DESCRIPTION}
    </Dialog>
  );
};
